import { render, staticRenderFns } from "./Seletor.vue?vue&type=template&id=3570b5aa"
import script from "./Seletor.vue?vue&type=script&lang=js"
export * from "./Seletor.vue?vue&type=script&lang=js"
import style0 from "./assets/seletor.styl?vue&type=style&index=0&prod&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports